import SettingsWelcomeScreenRoute from 'garaje/pods/visitors/settings/welcome-screen/route';

export default class VirtualFrontDeskSettingsWelcomeScreenRoute extends SettingsWelcomeScreenRoute {
  controllerName = 'visitors/settings/welcome-screen';
  templateName = 'visitors/settings/welcome-screen';
}
